module.exports = __webpack_public_path__ + "img/scene-smb.600cfd61.jpg";